<template>
  <div class="unit-mgmt">
    <div v-if="view === 'unitManagementView'" class="unit-mgmt-manage-view">
      <div class="main-title">
        <p>组织管理</p>
      </div>
      <div class="main-body">
        <div class="side-bar">
          <el-tree
            :data="unitTree"
            :props="defaultProps"
            node-key="unitNo"
            :highlight-current="true"
            :default-expanded-keys="checkedUnitList"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
        <div class="main-box">
          <div class="list">
            <div class="label">当前组织：</div>
            <div class="value long-width">{{ unitNavCrumbs }}</div>
          </div>
          <div class="list">
            <div class="label">组织编号</div>
            <div class="value">{{ unitInfo.unitNo }}</div>
            <div class="label">组织名称</div>
            <div class="value">{{ unitInfo.name }}</div>
            <div class="label">组织地址</div>
            <div class="value">{{ unitInfo.location }}</div>
            <div class="blue-btn ml10" @click="onEditUnitInfoBtnClick">编辑</div>
          </div>
          <div class="list" v-if="domainType != '2'">
            <div class="label">是否需要四要素验证及签合同：</div>
            <div class="value">{{ unitInfo.needSignContract == '1' ? "是" : "否" }}</div>
            <div class="label">限定组织用户凭证下绑定的电池才能换电：</div>
            <div class="value">{{ unitInfo.needCheckInBatteryAndVoucher == '1' ? "是" : "否" }}</div>
          </div>
          <div class="list" v-if="domainType != '2'">
            <div class="label">是否需要签约代扣：</div>
            <div class="value">{{ unitInfo.needSignWithHold == '1' ? "是" : "否" }}</div>
            <div class="label">是否使用商品价值配置（微信小程序）：</div>
            <div class="value">{{ unitInfo.needUseCommodityWorth == '1' ? "是" : "否" }}</div>
          </div>
          <div class="list" v-if="domainType != '2'">
            <div class="label">是否禁止柜外充电：</div>
            <div class="value" v-if="unitInfo.forbidCabinetOutsideCharging=='1'">是</div>
            <div class="value" v-else-if="unitInfo.forbidCabinetOutsideCharging=='2'">否</div>
            <div class="label" style="margin-left: 150px">被邀请人是否加入组织：</div>
            <div class="value" v-if="unitInfo.inviteeNeedJoinUnit=='1'">是</div>
            <div class="value" v-else-if="unitInfo.inviteeNeedJoinUnit=='2'">否</div>
          </div>
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="用户" name="user">
              <div class="list">
                <span>姓名/手机号</span>
                <el-input class="list-input" v-model="phoneAndName"></el-input>
                <span class="ml10">权限方案</span>
                <el-select class="list-input" v-model="authoritySchemeNo" placeholder="请选择">
                  <el-option
                    v-for="(value, key) in filterSchemeList"
                    :key="value"
                    :label="value"
                    :value="key"
                  ></el-option>
                </el-select>
                <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
                <div class="blue-btn ml10" @click="onAddUserBtnClick">关联用户</div>
                <div class="blue-btn ml10" @click="onImportBtnClick">导入</div>
                <div class="blue-btn ml10" style="width: 130px;" @click="confirmExportBtnClick">导出用户权限方案</div>
              </div>
              <table class="table-custom">
                <thead>
                <tr>
                  <th>成员编号</th>
                  <th>账户编号</th>
                  <th width="150px">姓名/用户手机号</th>
                  <th>权限方案</th>
                  <th>组织名称</th>
                  <th>联系人</th>
                  <th width="120px">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList.length>0">
                <tr v-for="item in dataList" :key="item.unitMemberNo">
                  <td>{{ item.unitMemberNo }}</td>
                  <td>{{ item.userAccountNo }}</td>
                  <td>
                    {{ (item.personName ? item.personName + "/" + item.phone : item.phone) + (item.unitName ? '(' + item.unitName + ')' : '') }}
                  </td>
                  <td>{{ item.authoritySchemeNo ? filterSchemeList[item.authoritySchemeNo] : '无权限' }}</td>
                  <td>{{ item.unitName }}</td>
                  <td>
                    <el-checkbox
                      @change="onCheckboxClick(item.unitMemberNo,item.defaultContactFlag,item)"
                      v-model="item.defaultContactFlag"
                      true-label="0"
                      false-label="1"
                    >默认联系人
                    </el-checkbox>
                  </td>
                  <td>
                    <div class="text-btn" @click="onEditUserBtnClick(item)">编辑</div>
                    <div class="text-btn" @click="onDeleteBtnClick(item.unitMemberNo)">删除</div>
                    <div
                      style="width: 103px; margin-top: 3px;"
                      class="text-btn"
                      @click="onViewContractBtnClick(item.userAccountNo, item.unitMemberNo)"
                    >查看合同
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="7">暂无数据</td>
                </tr>
                </tbody>
              </table>
              <div class="page-box">
                <!--<div class="page-count">第{{pageIndex}}页，当前页{{dataList.length}}条</div>-->
                <div
                  class="pre-btn"
                  disabled
                  :class="preBtnDisabled?'disabled':''"
                  @click="onPreBtnClick"
                >上一页
                </div>
                <div
                  class="next-btn"
                  :class="nextBtnDisabled?'disabled':''"
                  @click="onNextBtnClick"
                >下一页
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="设备" name="device">
              <div class="list">
                <span>设备编号</span>
                <el-input class="width-190" v-model="paramNo" placeholder="请输入通讯板编号/设备编号"></el-input>
                <span class="ml10">设备名称</span>
                <el-input class="list-input" v-model="deviceName"></el-input>
                <span class="ml10">设备类型</span>
                <el-select
                  class="list-input"
                  clearable
                  v-model="unitMemberSubType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(value, key) in unitMemberSubTypeMap"
                    :key="value"
                    :label="value"
                    :value="key"
                  ></el-option>
                </el-select>
              </div>
              <div class="list">
                <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
                <div class="blue-btn ml10" @click="onAddDeviceBtnClick">关联设备</div>
                <div class="blue-btn ml10" @click="onImportBtnClick">导入</div>
              </div>
              <table class="table-custom">
                <thead>
                <tr>
                  <th>成员编号</th>
                  <th>设备编号</th>
                  <th>通讯板编号/中控号</th>
                  <th>组织名称</th>
                  <th width="200px">设备类型/设备名称</th>
                  <th>车牌号</th>
                  <th width="145px">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList.length>0">
                <tr v-for="item in dataList" :key="item.unitMemberNo">
                  <td>{{ item.unitMemberNo }}</td>
                  <td>{{ item.deviceNo }}</td>
                  <td>{{ item.communicationBoardNo ? item.communicationBoardNo : item.controllerNo }}</td>
                  <td>{{ item.unitName }}</td>
                  <td>{{ item.deviceName ? item.unitMemberSubType + '/' + item.deviceName : item.unitMemberSubType }}
                  </td>
                  <td>{{ item.frameNo }}</td>
                  <td>
                    <div class="text-btn" @click="onDeleteBtnClick(item.unitMemberNo)">删除</div>
                    <div class="text-btn" style="width: 75px;"
                         @click="onDetailBtnClick(item.deviceNo,item.unitMemberSubTypeCode)">查看详情
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="7">暂无数据</td>
                </tr>
                </tbody>
              </table>
              <div class="page-box">
                <div
                  class="pre-btn"
                  disabled
                  :class="preBtnDisabled?'disabled':''"
                  @click="onPreBtnClick"
                >上一页
                </div>
                <div
                  class="next-btn"
                  :class="nextBtnDisabled?'disabled':''"
                  @click="onNextBtnClick"
                >下一页
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="下级组织" name="unit">
              <div class="list">
                <span>状态</span>
                <el-select class="list-input" clearable v-model="status" placeholder="请选择">
                  <el-option
                    v-for="(value, key) in unitStatusMap"
                    :key="value"
                    :label="value"
                    :value="key"
                  ></el-option>
                </el-select>
                <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
                <div class="blue-btn ml10" @click="onAddUnitBtnClick">关联组织</div>
              </div>
              <table class="table-custom">
                <thead>
                <tr>
                  <th>成员编号</th>
                  <th>组织编号</th>
                  <th>组织名称</th>
                  <th>组织地址</th>
                  <th>状态</th>
                  <th>操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList.length>0">
                <tr v-for="item in dataList" :key="item.unitMemberNo">
                  <td>{{ item.unitMemberNo }}</td>
                  <td>{{ item.unitNo }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.status }}</td>
                  <td>
                    <div
                      class="text-btn"
                      v-if="item.statusCode !==  '2'"
                      @click="onManageSubUnitBtnClick(item)"
                    >管理
                    </div>
                    <div
                      class="text-btn"
                      v-if="item.statusCode !==  '2'"
                      @click="onDeleteBtnClick(item.unitMemberNo)"
                    >删除
                    </div>
                    <div
                      class="text-btn"
                      v-if="item.statusCode ===  '2'"
                      @click="onRecoverBtnClick(item.unitMemberNo)"
                    >恢复
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="6">暂无数据</td>
                </tr>
                </tbody>
              </table>
              <div class="page-box">
                <div
                  class="pre-btn"
                  disabled
                  :class="preBtnDisabled?'disabled':''"
                  @click="onPreBtnClick"
                >上一页
                </div>
                <div
                  class="next-btn"
                  :class="nextBtnDisabled?'disabled':''"
                  @click="onNextBtnClick"
                >下一页
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <el-dialog title="编辑组织基本信息" :visible.sync="editUnitInfoDialogVisible" width="30%">
        <el-form label-position="right" label-width="80px" :model="editUnitInfo">
          <el-form-item label="组织编号">
            <el-input v-model="editUnitInfo.unitNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="组织名称">
            <el-input v-model="editUnitInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="组织地址">
            <el-input v-model="editUnitInfo.location"></el-input>
          </el-form-item>
          <el-form-item label-width="280px" label="是否需要四要素验证及签合同" v-if="domainType != '2'">
            <template>
              <el-radio v-model="editUnitInfo.needSignContract" label="1">是</el-radio>
              <el-radio v-model="editUnitInfo.needSignContract" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="限定组织用户凭证下绑定的电池才能换电" v-if="domainType != '2'">
            <template>
              <el-radio v-model="editUnitInfo.needCheckInBatteryAndVoucher" label="1">是</el-radio>
              <el-radio v-model="editUnitInfo.needCheckInBatteryAndVoucher" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否需要签约代扣" v-if="domainType != '2'">
            <template>
              <el-radio v-model="editUnitInfo.needSignWithHold" label="1">是</el-radio>
              <el-radio v-model="editUnitInfo.needSignWithHold" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否使用商品价值配置（微信小程序）" v-if="domainType != '2'">
            <template>
              <el-radio v-model="editUnitInfo.needUseCommodityWorth" label="1">是</el-radio>
              <el-radio v-model="editUnitInfo.needUseCommodityWorth" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否禁止柜外充电" v-if="domainType != '2'">
            <template>
              <el-checkbox v-model="editUnitInfo.forbidCabinetOutsideCharging1" @change="bindEditCheckBox1">是
              </el-checkbox>
              <el-checkbox v-model="editUnitInfo.forbidCabinetOutsideCharging2" @change="bindEditCheckBox2">否
              </el-checkbox>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="被邀请人是否加入组织" v-if="domainType != '2'">
            <el-radio v-model="editUnitInfo.inviteeNeedJoinUnit" label="1">是</el-radio>
            <el-radio v-model="editUnitInfo.inviteeNeedJoinUnit" label="2">否</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editUnitInfoDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="editUnitInfoConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增用户" :visible.sync="addUserDialogVisible" width="30%">
        <el-form label-position="right" label-width="80px" :model="addUserData">
          <el-form-item label="用户">
            <el-input v-model="addUserData.sourceNo" placeholder="账户编号或手机号"></el-input>
          </el-form-item>
          <el-form-item label="权限方案">
            <el-select v-model="addUserData.authoritySchemeNo" placeholder="请选择">
              <el-option
                v-for="(value, key) in confSchemeList"
                :key="value"
                :label="value"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUserDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddUserConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑用户" :visible.sync="editUserDialogVisible" width="30%">
        <el-form label-position="right" label-width="80px" :model="editUserData">
          <el-form-item label="成员编号">
            <el-input v-model="editUserData.unitMemberNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="账户编号">
            <el-input v-model="editUserData.userAccountNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="权限方案">
            <el-select v-model="editUserData.authoritySchemeNo">
              <el-option
                v-for="(value, key) in confSchemeList"
                :key="value"
                :label="value"
                :value="key"
              ></el-option>
            </el-select>
            <el-button
              v-if="editUserData.authoritySchemeNo === '-1'"
              @click="editUserAuthorityScheme(editUserData.unitMemberNo,editUserData.userAccountNo)"
            >编辑
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editUserDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onEditUserConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入文件" :visible.sync="uploadDialogVisible" width="30%">
        <el-form label-position="right" label-width="80px" :model="addUserData">
          <el-form-item label>
            <el-upload
              ref="fileUpload"
              action
              accept=".xls, .xlsx"
              :limit="1"
              :auto-upload="false"
              :on-change="handleFile"
              :file-list="uploadFileList"
            >
              <el-button>添加文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onImportBtnConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增设备" :visible.sync="addDeviceDialogVisible" width="30%">
        <el-form label-position="right" label-width="140px" :model="addDeviceData">
          <el-form-item label="设备类型">
            <el-select v-model="addDeviceData.unitMemberSubType" placeholder="请选择">
              <el-option
                v-for="(value, key) in unitMemberSubTypeMap"
                :key="value"
                :label="value"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-bind:label="'设备编号' + (addDeviceData.unitMemberSubType != 26 ? '/名称' : '')">
            <el-input v-model="addDeviceData.deviceNoOrName"
                      v-bind:placeholder="'请输入设备编号' + (addDeviceData.unitMemberSubType != 26 ? '/名称' : '')"></el-input>
          </el-form-item>
          <el-form-item v-bind:label="addDeviceData.unitMemberSubType != 26 ? '通讯板编号/二维码' : '中控号'">
            <el-input v-model="addDeviceData.linkOrCommunicationBoardNo"
                      v-bind:placeholder="'请输入' + (addDeviceData.unitMemberSubType != 26 ? '通讯板编号/二维码' : '中控号')"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDeviceDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddDeviceConfirm">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增组织" :visible.sync="addUnitDialogVisible" width="30%">
        <el-form label-position="right" label-width="80px" :model="addUnitData">
          <el-form-item label="组织名称">
            <el-input v-model="addUnitData.name"></el-input>
          </el-form-item>
          <el-form-item label="组织地址">
            <el-input v-model="addUnitData.location"></el-input>
          </el-form-item>
          <el-form-item label-width="280px" label="是否需要四要素验证及签合同" v-if="domainType != '2'">
            <template>
              <el-radio v-model="addUnitData.needSignContract" label="1">是</el-radio>
              <el-radio v-model="addUnitData.needSignContract" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="限定组织用户凭证下绑定的电池才能换电" v-if="domainType != '2'">
            <template>
              <el-radio v-model="addUnitData.needCheckInBatteryAndVoucher" label="1">是</el-radio>
              <el-radio v-model="addUnitData.needCheckInBatteryAndVoucher" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否需要签约代扣" v-if="domainType != '2'">
            <template>
              <el-radio v-model="addUnitData.needSignWithHold" label="1">是</el-radio>
              <el-radio v-model="addUnitData.needSignWithHold" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否使用商品价值配置（微信小程序）" v-if="domainType != '2'">
            <template>
              <el-radio v-model="addUnitData.needUseCommodityWorth" label="1">是</el-radio>
              <el-radio v-model="addUnitData.needUseCommodityWorth" label="2">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="是否禁止柜外充电" v-if="domainType != '2'">
            <template>
              <el-checkbox v-model="addUnitData.forbidCabinetOutsideCharging1" @change="bindAddCheckBox1">是
              </el-checkbox>
              <el-checkbox v-model="addUnitData.forbidCabinetOutsideCharging2" @change="bindAddCheckBox2">否
              </el-checkbox>
            </template>
          </el-form-item>
          <el-form-item label-width="280px" label="被邀请人是否加入组织" v-if="domainType != '2'">
            <el-radio v-model="addUnitData.inviteeNeedJoinUnit" label="1">是</el-radio>
            <el-radio v-model="addUnitData.inviteeNeedJoinUnit" label="2">否</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUnitDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onAddUnitConfirm">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <userMgmtContractView
      v-if="view === 'contractView'"
      :userAccountNo="userAccountNo"
      :unitMemberNo="unitMemberNo"
    ></userMgmtContractView>
  </div>
</template>

<script>
import userMgmtContractView from "./userMgmtContractView.vue";
import Utils from "../../utils/utils";

export default {
  name: "unitMgmtManageView",
  components: {
    userMgmtContractView
  },
  data() {
    return {
      unitNavCrumbs: "",
      activeName: "user",
      checkedUnitList: [],
      unitInfo: {
        unitNo: "",
        name: "",
        location: ""
      },
      editUnitInfo: {
        unitNo: "",
        name: "",
        location: "",
        needSignContract: "2",
        needCheckInBatteryAndVoucher: "2",
        needSignWithHold: '2',
        needUseCommodityWorth: '2',
        forbidCabinetOutsideCharging: '',
        forbidCabinetOutsideCharging1: false,
        forbidCabinetOutsideCharging2: false,
        inviteeNeedJoinUnit: ''
      },
      editUnitInfoDialogVisible: false,
      addUserData: {
        checkPhone: 1,
        sourceNo: "",
        authoritySchemeNo: "-2"
      },
      addUserDialogVisible: false,
      authoritySchemeList: {},
      authoritySchemeNo: "",
      phoneAndName: "",
      dataList: [],
      preBtnDisabled: true,
      nextBtnDisabled: true,
      beginIndex: 0,
      pageSize: 10,
      file: null,
      uploadDialogVisible: false,
      uploadFileList: [],
      editUserData: {
        unitMemberNo: "",
        userAccountNo: "",
        authoritySchemeNo: ""
      },
      editUserDialogVisible: false,
      unitMemberSubType: "",
      unitMemberSubTypeMap: {
        "20": "充电桩",
        "21": "换电柜",
        "22": "电池",
        "25": "充电柜",
        "26": "电动车"
      },
      deviceName: "",
      paramNo: "",
      addDeviceDialogVisible: false,
      addDeviceData: {
        unitMemberSubType: "20",
        deviceNoOrName: "",
        linkOrCommunicationBoardNo: ""
      },
      status: "1",
      unitStatusMap: {
        "1": "正常",
        "2": "删除"
      },
      addUnitDialogVisible: false,
      addUnitData: {
        name: "",
        location: "",
        needSignContract: "2",
        needCheckInBatteryAndVoucher: "2",
        needSignWithHold: '2',
        needUseCommodityWorth: '2',
        forbidCabinetOutsideCharging: '',
        forbidCabinetOutsideCharging1: false,
        forbidCabinetOutsideCharging2: false,
        inviteeNeedJoinUnit: '2'
      },
      unitTree: [],
      defaultProps: {
        children: "subUnit",
        label: "name"
      },
      view: "unitManagementView",
      userAccountNo: "",
      unitMemberNo: "",
      domainType: ''
    };
  },
  computed: {
    filterSchemeList() {
      return {
        "": "全部",
        ...this.authoritySchemeList,
        "-1": "自定义",
        "-2": "无权限",
        "-99": "所有权限"
      };
    },
    confSchemeList() {
      return {
        "-2": "无权限",
        ...this.authoritySchemeList,
        "-1": "自定义",
        "-99": "所有权限"
      };
    },
    memberType() {
      const map = {
        user: 2,
        device: 3,
        unit: 1
      };
      return map[this.activeName];
    }
  },
  watch: {
    memberType() {
      this.onQueryBtnClick();
    },
    $route() {
      this.unitInfo = this.$qs.parse(this.$route.query);
      this.queryUnitMember();
      this.getUnitLevelInfo();
    }
  },
  mounted() {
    this.unitInfo = this.$qs.parse(this.$route.query);
    this.queryAllAuthorityScheme();
    this.queryManagedUnit();
    this.getUnitLevelInfo();
    this.queryUnitMember();
    let domain = Utils.getDomain();
    if (domain == 'iot.lititi.com' || domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com' || domain == 'leasehold-dev.lititi.com') {
      this.domainType = '2';
    }
  },
  methods: {
    queryAllAuthorityScheme() {
      this.$http
        .post("/managementPlatform/authority/queryAllAuthorityScheme")
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          this.authoritySchemeList = res.mdata && res.mdata.authoritySchemeList;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUnitLevelInfo() {
      let params = {
        unitNo: this.unitInfo.unitNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/getUnitLevelInfo",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          this.unitInfo.needCheckInBatteryAndVoucher = res.mdata.unitLevelInfo[0].needCheckInBatteryAndVoucherStr == '是' ? '1' : '2';
          this.unitInfo.needSignContract = res.mdata.unitLevelInfo[0].needSignContractStr == '是' ? '1' : '2';
          this.unitInfo.needSignWithHold = res.mdata.unitLevelInfo[0].needSignWithHoldStr == '是' ? '1' : '2';
          this.unitInfo.needUseCommodityWorth = res.mdata.unitLevelInfo[0].needUseCommodityWorthStr == '是' ? '1' : '2';
          this.unitInfo.forbidCabinetOutsideCharging1 = res.mdata.unitLevelInfo[0].forbidCabinetOutsideCharging == '1';
          this.unitInfo.forbidCabinetOutsideCharging2 = res.mdata.unitLevelInfo[0].forbidCabinetOutsideCharging == '2';
          this.unitInfo.forbidCabinetOutsideCharging = res.mdata.unitLevelInfo[0].forbidCabinetOutsideCharging;
          this.unitInfo.inviteeNeedJoinUnit = res.mdata.unitLevelInfo[0].inviteeNeedJoinUnit;
          let unitLevelInfo =
            res.mdata &&
            res.mdata.unitLevelInfo &&
            res.mdata.unitLevelInfo.reverse();
          this.unitNavCrumbs = unitLevelInfo.map(item => item.name).join(" > ");
          this.checkedUnitList = unitLevelInfo.map(item => item.unitNo);
        })
        .catch(err => {
          console.log(err);
        });
    },
    queryManagedUnit() {
      let params = {
        authorityType: 209
      }
      this.$http
        .post("/managementPlatform/unit/queryManagedUnit", this.$qs.stringify(params))
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          this.unitTree = res.mdata && res.mdata.unitTree;
        })
        .catch(err => {
          console.log(err);
        });
    },
    queryUnitMember() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        memberType: this.memberType,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      if (this.memberType === 2) {
        params.phoneAndName = this.phoneAndName;
        params.authoritySchemeNo = this.authoritySchemeNo;
      } else if (this.memberType === 3) {
        params.unitMemberSubType = this.unitMemberSubType;
        params.deviceName = this.deviceName;
        params.paramNo = this.paramNo;
      } else if (this.memberType === 1) {
        params.status = this.status;
      }
      this.$http
        .post(
          "/managementPlatform/unit/queryUnitMember",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          this.dataList = [];
          for (let key in res.mdata) {
            this.dataList = res.mdata[key];
          }
          this.resetPreAndNextBtn(this.dataList.length);
          this.dataList.length > this.pageSize && this.dataList.pop();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onEditUnitInfoBtnClick() {
      Object.assign(this.editUnitInfo, this.unitInfo);
      this.editUnitInfoDialogVisible = true;
    },
    editUnitInfoConfirm() {
      let params = {
        unitNo: this.editUnitInfo.unitNo,
        unitName: this.editUnitInfo.name,
        location: this.editUnitInfo.location,
        needSignContract: this.editUnitInfo.needSignContract,
        needCheckInBatteryAndVoucher: this.editUnitInfo.needCheckInBatteryAndVoucher,
        needSignWithHold: this.editUnitInfo.needSignWithHold,
        needUseCommodityWorth: this.editUnitInfo.needUseCommodityWorth,
        forbidCabinetOutsideCharging: this.editUnitInfo.forbidCabinetOutsideCharging,
        inviteeNeedJoinUnit: this.editUnitInfo.inviteeNeedJoinUnit,
      };
      this.$http
        .post(
          "/managementPlatform/unit/addOrUpdateUnitInfo",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.editUnitInfoDialogVisible = false;
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true
          });
          Object.assign(this.unitInfo, this.editUnitInfo);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryUnitMember();
    },
    onRefreshBtnClick() {
      this.beginIndex = 0;
      this.dataList = [];
      this.queryUnitMember();
    },
    onAddUserBtnClick() {
      this.addUserData.checkPhone = 1;
      this.addUserData.sourceNo = "";
      this.addUserData.authoritySchemeNo = "-2";
      this.addUserDialogVisible = true;
    },
    onAddUserConfirm() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        checkPhone: this.addUserData.checkPhone,
        sourceNo: this.addUserData.sourceNo,
        authoritySchemeNo: this.addUserData.authoritySchemeNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/addUnitMemberForUserAccount",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          if (res.mdata && res.mdata.checkPhone) {
            this.addUserData.checkPhone = 2;
            this.$confirm(
              `该手机号${res.mdata.checkPhone}未注册,是否确认新增用户？`
            ).then(() => {
              this.onAddUserConfirm();
            });
          } else {
            this.addUserDialogVisible = false;
            this.$message({
              type: "success",
              message: "新增成功",
              center: true
            });
            this.onRefreshBtnClick();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleFile(file, fileList) {
      this.file = file.raw;
      return false;
    },
    onImportBtnClick() {
      this.file = null;
      this.uploadDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.fileUpload.clearFiles();
      });
    },
    onImportBtnConfirm() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        uploadFile: this.file
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      this.$http
        .post("/managementPlatform/unit/addUnitMemberByFile", formData)
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.uploadDialogVisible = false;
          this.$message({
            type: "success",
            message: "上传成功",
            center: true
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    confirmExportBtnClick() {
      let self = this;
      this.$confirm("是否确认导出?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.onExportBtnClick();
        })
        .catch(action => {
        });
    },
    onExportBtnClick() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        phoneAndName: this.phoneAndName,
        authoritySchemeNo: this.authoritySchemeNo
      };
      this.$http
        .post(
          "/managementPlatform/electricity/userAuthoritySchemeExport",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.$router.push("/managePage/downloadTask");
        })
        .catch(err => {
          console.log(err);
        });
    },
    onCheckboxClick(unitMemberNo, defaultContactFlag, item) {
      const operateStr = defaultContactFlag === "0" ? "设置" : "取消";
      this.$confirm(`是否确认${operateStr}默认联系人？`)
        .then(() => {
          this.updateUnitMember(unitMemberNo, defaultContactFlag);
        })
        .catch(() => {
          item.defaultContactFlag = defaultContactFlag === "0" ? "1" : "0";
        });
    },
    updateUnitMember(unitMemberNo, defaultContactFlag) {
      let params = {
        unitMemberNo: unitMemberNo,
        defaultContactFlag: defaultContactFlag
      };
      this.$http
        .post(
          "/managementPlatform/unit/updateUnitMember",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    onEditUserBtnClick(item) {
      this.editUserData.unitMemberNo = item.unitMemberNo;
      this.editUserData.userAccountNo = item.userAccountNo;
      this.editUserData.authoritySchemeNo = item.authoritySchemeNo || "-2";
      this.editUserDialogVisible = true;
    },
    onEditUserConfirm() {
      let params = {
        unitMemberNo: this.editUserData.unitMemberNo,
        authoritySchemeNo: this.editUserData.authoritySchemeNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/editUnitMemberForUserAccount",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.editUserDialogVisible = false;
          this.$message({
            type: "success",
            message: "编辑成功",
            center: true
          });
          this.queryUnitMember();
        })
        .catch(err => {
          console.log(err);
        });
    },
    editUserAuthorityScheme(unitMemberNo, userAccountNo) {
      const qs = this.$qs.stringify({
        unitMemberNo,
        userAccountNo
      });
      this.$router.push("/managePage/unitMgmtAuthoritySchemeEditView?" + qs);
    },
    onDeleteBtnClick(unitMemberNo) {
      this.$confirm("是否确认删除？").then(() => {
        this.deleteUnitMember(unitMemberNo);
      });
    },
    onViewContractBtnClick(userAccountNo, unitMemberNo) {
      this.userAccountNo = userAccountNo;
      this.unitMemberNo = unitMemberNo;
      this.view = "contractView";
    },
    back() {
      this.view = "unitManagementView";
    },
    deleteUnitMember(unitMemberNo) {
      let params = {
        unitMemberNo: unitMemberNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/deleteUnitMember",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
            center: true
          });
          this.queryUnitMember();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onAddDeviceBtnClick() {
      this.addDeviceData.deviceNoOrName = "";
      this.addDeviceData.unitMemberSubType = "20";
      this.addDeviceData.linkOrCommunicationBoardNo = "";
      this.addDeviceDialogVisible = true;
    },
    onAddDeviceConfirm() {
      let params = {
        unitNo: this.unitInfo.unitNo,
        deviceNoOrName: this.addDeviceData.deviceNoOrName,
        unitMemberSubType: this.addDeviceData.unitMemberSubType,
        linkOrCommunicationBoardNo: this.addDeviceData
          .linkOrCommunicationBoardNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/addUnitMemberForDevice",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.addDeviceDialogVisible = false;
          this.$message({
            type: "success",
            message: "新增成功",
            center: true
          });
          this.onRefreshBtnClick();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onAddUnitBtnClick() {
      this.addUnitData.name = "",
        this.addUnitData.location = "",
        this.addUnitData.needSignContract = "2",
        this.addUnitData.needCheckInBatteryAndVoucher = "2",
        this.addUnitData.needSignWithHold = '2',
        this.addUnitData.needUseCommodityWorth = '2',
        this.addUnitData.forbidCabinetOutsideCharging = '',
        this.addUnitData.forbidCabinetOutsideCharging1 = false,
        this.addUnitData.forbidCabinetOutsideCharging2 = false,
        this.addUnitDialogVisible = true;
    },
    onAddUnitConfirm() {
      let params = {
        parentUnitNo: this.unitInfo.unitNo,
        unitName: this.addUnitData.name,
        location: this.addUnitData.location,
        needSignContract: this.addUnitData.needSignContract,
        needCheckInBatteryAndVoucher: this.addUnitData.needCheckInBatteryAndVoucher,
        needSignWithHold: this.addUnitData.needSignWithHold,
        needUseCommodityWorth: this.addUnitData.needUseCommodityWorth,
        forbidCabinetOutsideCharging: this.addUnitData.forbidCabinetOutsideCharging,
        inviteeNeedJoinUnit: this.addUnitData.inviteeNeedJoinUnit,
      };
      this.$http
        .post(
          "/managementPlatform/unit/addOrUpdateUnitInfo",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.addUnitDialogVisible = false;
          this.$message({
            type: "success",
            message: "新增成功",
            center: true
          });
          Object.assign(this.unitInfo, this.addUnitData);
          this.onRefreshBtnClick();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onManageSubUnitBtnClick(item) {
      const unitInfo = {
        unitNo: item.unitNo,
        name: item.name,
        location: item.location
      };
      this.$router.push(
        "/managePage/unitMgmtManageView?" + this.$qs.stringify(unitInfo)
      );
    },
    onRecoverBtnClick(unitMemberNo) {
      this.$confirm("是否确认恢复该组织？").then(() => {
        this.recoverUnitMember(unitMemberNo);
      });
    },
    recoverUnitMember(unitMemberNo) {
      let params = {
        unitMemberNo: unitMemberNo
      };
      this.$http
        .post(
          "/managementPlatform/unit/recoverUnitMember",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "操作失败!",
              center: true
            });
            return;
          }
          this.$message({
            type: "success",
            message: "恢复成功",
            center: true
          });
          this.queryUnitMember();
        })
        .catch(err => {
          console.log(err);
        });
    },
    bindEditCheckBox1(value) {
      if (value) {
        this.editUnitInfo.forbidCabinetOutsideCharging2 = false
        this.editUnitInfo.forbidCabinetOutsideCharging = 1;
      } else {
        this.editUnitInfo.forbidCabinetOutsideCharging = '';
      }
    },
    bindEditCheckBox2(value) {
      if (value) {
        this.editUnitInfo.forbidCabinetOutsideCharging1 = false
        this.editUnitInfo.forbidCabinetOutsideCharging = 2;
      } else {
        this.editUnitInfo.forbidCabinetOutsideCharging = '';
      }
    },
    bindAddCheckBox1(value) {
      if (value) {
        this.addUnitData.forbidCabinetOutsideCharging2 = false
        this.addUnitData.forbidCabinetOutsideCharging = 1;
      } else {
        this.addUnitData.forbidCabinetOutsideCharging = '';
      }
    },
    bindAddCheckBox2(value) {
      if (value) {
        this.addUnitData.forbidCabinetOutsideCharging1 = false
        this.addUnitData.forbidCabinetOutsideCharging = 2;
      } else {
        this.addUnitData.forbidCabinetOutsideCharging = '';
      }
    },
    handleNodeClick(item) {
      const unitInfo = {
        unitNo: item.unitNo,
        name: item.name,
        location: item.location
      };
      this.$router.push(
        "/managePage/unitMgmtManageView?" + this.$qs.stringify(unitInfo)
      );
    },
    onPreBtnClick: function () {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryUnitMember();
    },
    onNextBtnClick: function () {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryUnitMember();
    },
    resetPreAndNextBtn: function (length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onDetailBtnClick(number, type) {
      switch (type) {
        case "20": {
          this.$router.push('/managePage/chargeMgmt?primaryDeviceNo=' + number);
          break;
        }
        case "21": {
          this.$router.push('/managePage/batterySwapMgmt?primaryDeviceNo=' + number);
          break;
        }
        case "22": {
          this.$router.push('/managePage/batteryMgmt?primaryDeviceNo=' + number);
          break;
        }
        case "25": {
          this.$router.push('/managePage/chargeCabinetMgmt?primaryDeviceNo=' + number);
          break;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-custom {
  width: 100%;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}

.side-bar {
  vertical-align: top;
  display: inline-block;
  width: 180px;
  min-height: 460px;
  border-right: 1px solid #ccc;
}

.main-box {
  vertical-align: top;
  display: inline-block;
  width: 890px;
  min-height: 460px;
}

.list {
  line-height: 30px;
  margin: 10px;

  .label {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    display: inline-block;
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .value {
    font-size: 12px;
    color: rgba(51, 51, 51, 1);
    display: inline-block;
    height: 30px;
    width: 140px;
    padding: 0 10px;
  }

  .list-input {
    width: 140px;
  }
}

.width-190 {
  width: 190px !important;
}

.long-width {
  width: 700px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  white-space: nowrap;
}
</style>
<style>
.unit-mgmt-manage-view .el-checkbox__label {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/unitMgmtManageView.vue